export default __webpack_public_path__ + "static/media/body-2.7c913b10.jpg";